import { huggg as hugggApi } from '@huggg/back-bar';
import { combineReducers } from 'redux';
import initialStateLoader from '../initialState';

export const CLEAR = 'hugggs/CLEAR';
export const LOAD = 'hugggs/LOAD';
export const LOAD_SUCCESS = 'hugggs/LOAD_SUCCESS';
export const LOAD_FAILURE = 'hugggs/LOAD_FAILURE';

const defaultState = initialStateLoader().hugggs;

const status = (state = defaultState.status, { type, payload }) => {
  switch (type) {
    case LOAD:
      return {
        ...state,
        loaded: false,
        loading: true,
      };

    case LOAD_SUCCESS:
      return {
        ...state,
        loaded: true,
        loading: false,
      };

    case LOAD_FAILURE:
      return {
        ...state,
        loaded: true,
        loading: false,
      };

    case CLEAR:
      return {
        loaded: false,
        loading: false,
      };

    default:
      return state;
  }
};

const byId = (state = defaultState.byId, { type, payload }) => {
  switch (type) {
    case LOAD_SUCCESS:
      return {
        ...state,
        ...payload.hugggs,
      };

    case CLEAR:
      return {};

    default:
      return state;
  }
};

const allIds = (state = defaultState.allIds, { type, payload }) => {
  switch (type) {
    case LOAD_SUCCESS:
      return [...state, ...Object.keys(payload.hugggs)].filter(
        (item, index, array) => array.indexOf(item) === index,
      );

    case CLEAR:
      return [];

    default:
      return state;
  }
};

export default combineReducers({ allIds, byId, status });

export const fetchHugggs = (options) => (dispatch) => {
  dispatch({ type: LOAD });

  hugggApi
    .fetch(options)
    .then((data) => {
      const byId = {};

      data.forEach((item) => (byId[item.id] = item));

      dispatch({
        type: LOAD_SUCCESS,
        payload: { hugggs: byId },
      });
    })
    .catch(() => {
      dispatch({
        type: LOAD_FAILURE,
      });
    });
};

export const clearHugggs = () => (dispatch) => dispatch({ type: CLEAR });

export const getAllhugggs = (state) =>
  state.hugggs.allIds.map((id) => state.hugggs.byId[id]);

export const getHasLoaded = (state) => state.hugggs.status.loaded;
export const getIsLoading = (state) => state.hugggs.status.loading;
